import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

// Presentation only: FullStack remains responsible for selections, prices and cart requests.
function refreshSelection(form) {
  if (!form?.isConnected || !form.addToCartButtonContainer) return;
  const list = form.querySelector('.veyre-selection-clear[data-ref="toggle-cross-sells"]');
  if (!list || typeof list.getSelectedItems !== 'function' || !list.crossSells) return;
  for (const card of list.crossSells) {
    const visiblePrice = card.querySelector('[data-veyre-base-price]');
    const price = typeof card.getPrices === 'function' ? card.getPrices().price : Number(card.dataset.price);
    if (visiblePrice && Number.isFinite(price)) visiblePrice.textContent = formatMoney(price);
  }
  const mainQuantity = Math.max(1, parseInt(form.quantitySelectorInput?.value, 10) || 1);
  const extraQuantity = list.getSelectedItems().items.reduce((sum, item) => sum + item.quantity, 0);
  const count = mainQuantity + extraQuantity;
  const prices = form.getCurrentTotalPrice();
  const summary = list.querySelector('[data-veyre-selection-summary]');
  const reduction = count >= 3 ? ' · −25 %' : count >= 2 ? ' · −20 %' : '';
  if (summary && Number.isFinite(prices.price)) {
    summary.textContent = `${count} plaid${count > 1 ? 's' : ''} sélectionné${count > 1 ? 's' : ''}${reduction} · Total ${formatMoney(prices.price)}`;
  }
  list.dataset.selectedCount = String(count);
}
function refreshAll() {
  document.querySelectorAll('product-form').forEach(refreshSelection);
}
function scheduleRefresh(event) {
  const form = event.target?.closest?.('product-form');
  if (form?.querySelector('.veyre-selection-clear')) requestAnimationFrame(() => refreshSelection(form));
}
Promise.all([
  customElements.whenDefined('product-form'),
  customElements.whenDefined('toggle-cross-sell-list'),
  customElements.whenDefined('toggle-cross-sell'),
]).then(() => requestAnimationFrame(refreshAll));
document.addEventListener('click', scheduleRefresh);
document.addEventListener('change', scheduleRefresh);
document.addEventListener(ThemeEvents.formUpdated, scheduleRefresh);
document.addEventListener('shopify:section:load', () => requestAnimationFrame(refreshAll));
